import React from "react";
import { Field } from "formik";
import { isFunction } from "lodash";

const validateField = value => {
  let error;
  if (!value) {
    error = "This field is required";
  }
  return error;
};

class Text extends React.PureComponent {
  render() {
    const { name, validate, title, errors, submitCount, touched } = this.props;

    let className =
      ((errors && errors[name] && (touched[name] || !!submitCount)
        ? "error is-invalid"
        : "") + " text-input form-control ")+ (this.props.className !== undefined && this.props.className);

    return (
      <React.Fragment>
        {title &&  <label>{title}</label>}
        <div className="input-group mb-3">
          <Field
            {...this.props}
            name={name}
            className={className}
            validate={
              validate && (isFunction(validate) ? validate : validateField)
            }
          />
          {errors && errors[name] && touched[name] && (
            <div className="invalid-feedback">{errors[name]}</div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default Text;
